module.exports = __webpack_public_path__ + "static/img/setting.b0ecd3d6.png";